export function isVisible(el) {
  return window.getComputedStyle(el).display !== 'none';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/tiny-slider/src/helpers/isVisible.js
// module id = 91
// module chunks = 0